import React, { useState, useEffect, useContext } from "react";
import Web3 from "web3";
import {
  BrowserRouter as Router,
  useLocation,
  Route,
  Routes,
  Link,
  useNavigate,
  useHistory
} from "react-router-dom";
import Premium from "./components/Premium";
// import Freemium from "./components/Freemium";
import Blacklisted from "./components/Blacklisted";
import "./App.scss";
import { SocialIcon } from "react-social-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Explorer from "./components/Explorer";
import axios from "axios";
import Registration from "./components/Register";
import Playground from "./components/Playground";
import Swal from "sweetalert2";
import Login from "./components/Login";
import PaymentPage from "./components/PaymentPage";
import Profile from "./components/Profile";
import PasswordResetRequest from "./components/PasswordResetRequest";
// import Chatbot from "./components/Chatbot";


import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';


import PasswordReset from "./components/PasswordReset";

import UserProvider from "./context/UserProvider";

import UserContext from "./context/userContext";

const TRHESHOLD = 25;
// const stripePromise = loadStripe('');
const stripePromise = loadStripe("pk_live_51HTKNAD4EwKsCcFfLsEvbIDghHRsyPflE5zJW5ChrD8yxje3QZdryvjLNRE7fBYS0E2ERc96bTooxiRdW90YKh2500Z4uxfqo4");


function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}


function Navbar({ setAccount, setTokenBalance, setUserToken }) {
  const [account, updateAccount] = useState(null);
  const [tokenBalance, updateTokenBalance] = useState("0");
  const [userToken, updateUserToken] = useState(localStorage.getItem('authToken'));
  const [isTwitterAuthenticated, setIsTwitterAuthenticated] = useState(false);
  const [hasFollowedAndRetweeted, setHasFollowedAndRetweeted] = useState(false);
  const [hasFollowed, setHasFollowed] = useState(false);
  const [hasRetweeted, setHasRetweeted] = useState(false);
  const [twitterUsername, setTwitterUsername] = useState(null);
  const [twitterUserId, setTwitterUserId] = useState(null);
  const [isBalanceFetched, setIsBalanceFetched] = useState(false);
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const location = useLocation();
  const [imageLinks, setImageLinks] = useState([]);
  const [activeStripeUser, setActiveStripeUser] = useState (false);
  const [web3, setWeb3] = useState(null);
  const [accounts, setAccounts] = useState(null);


  const { stripeUser, setStripeUser, premiumToken, setPremiumToken } = useContext(UserContext);

  //   const tokenAddress = "0xEe5EeC8C76449d64b09A9f7Ebbb3B90455F55944";
  const tokenAddress = "0x3DAfbdeaA2e17380D27B80E395dEE1d281D408d7";
  const tokenThreshold = 25;

  const navigate = useNavigate();

  useEffect(() => {
    if (window.ethereum) {
      const handleAccountsChanged = (accounts) => {
        console.log('Wallet disconnected');
        updateUserToken(null);
        setUserToken (null);
        updateAccount (null);
        setAccount (null);
        setStripeUser (null);
      //   alert ("wallet disconnected");

        localStorage.removeItem('authToken');
        localStorage.removeItem ("isStripeActive");
        if (accounts.length === 0) {
          // Wallet is disconnected
        //   console.log('Wallet disconnected');
        //   updateUserToken(null);
        //   setUserToken (null);
        //   updateAccount (null);
        //   setAccount (null);
        // //   alert ("wallet disconnected");

        //   localStorage.removeItem('authToken');
        localStorage.removeItem ("isStripeActive");
        } 
        // Handle other logic for accounts change if needed
        else if (accounts[0] !== account) {
            // alert ("wallet changed!");
            
        }
      };
  
      // Add the listener
      window.ethereum.on('accountsChanged', handleAccountsChanged);
  
      // Clean up the listener when the component is unmounted
      return () => {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      };
    }
  }, []);
  

  useEffect(() => {
    // console.log ("premiumToken", premiumToken);
    const token = localStorage.getItem('authToken');

    if (token) {
        // console.log ("token", token);

        updateUserToken (token);
        setUserToken (token);
        // Get user details from backend using the token
        fetch('https://www.dreamgirlstudio.ai/user-details', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log ('here', data);
            if (data && data.username) {
                // Update context or state with username details
                setStripeUser({ username: data.username });
                console.log ('data.username', data.username);
            } else if (data && data.address) {
                setAccount (data.address);
                updateAccount (data.address);
                setTokenBalance (data.balance);
                updateTokenBalance (data.balance);
            }
        })
        .catch(error => {
            console.error('Error fetching user details:', error);
        });
    }
  }, [userToken, location.pathname]);

  useEffect (() => {
        // console.log ('userToken', userToken);
    // updateUserToken (localStorage.getItem ("authToken"));
    // setUserToken (localStorage.getItem ("authToken"));
    if (location.pathname === "/premium") {
        if (!userToken) {
            Swal.fire({
            title: "Welcome to Premium Mode!",
            html: `<div class='instructionContainer'>With Premium Mode, you can enjoy benefits such as <strong style='color: purple'>removing the watermark, saving all of your Dream Girls, generating 4 girls at once and further customizing your girls!</strong> 
                <hr />
                To use Premium mode, you can either:
                <ul>
                    <li>• Connect your Metamask wallet to verify your $DREAM token balance</li>
                    <li style="margin: auto; width: 30%;"><strong><i>-&nbsp;OR&nbsp;-</i></strong></li>
                    <li>• Log into your account with an active subscription (or register if you don't have an account yet)</li>
                </ul>
                </div>`,
    
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Log in | Register",
            showCancelButton: true,
            cancelButtonText: "Verify with Metamask", // Set cancel button text
            cancelButtonColor: "#F6851C", // Color of the cancel button
            }).then((result) => {
            if (result.isConfirmed) {
                // Handle the logic when "Log in | Register" is clicked
                navigate("/register");
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Handle the logic when "Verify..." is clicked
                connectWalletToken();
            }
            });
        }
        }
  }, []);


  useEffect(() => {
    const checkTwitterAuth = async () => {
      const urlParams = new URLSearchParams(location.search);
      const isBlacklisted = urlParams.get("blacklisted");

      if (isBlacklisted && isBlacklisted === "true") {
        setIsBlacklisted(true); // Assuming you've already defined this state
      } else {
        const token = urlParams.get("token");
        if (token) {
          try {
            const response = await fetch(
              `https://www.dreamgirlstudio.ai/verify-token?token=${token}`
            );
            const data = await response.json();
            if (data.valid) {
              setIsTwitterAuthenticated(true);
              setTwitterUsername(data.username);
              setTwitterUserId(data.userId);
            }
          } catch (err) {
            console.error("Error verifying token:", err);
          }
        }
      }
    };

    const previouslyConnected = localStorage.getItem("metamaskConnected");
    if (previouslyConnected && window.ethereum) {
      //   connectMetamask();
    }

    checkTwitterAuth();
    // connectMetamask ();
  }, [location.search]);


  function shortenString(str) {
    if (str.length <= 11) {
      return str;
    }
    const start = str.substring(0, 9);
    const end = str.substring(str.length - 7);
    return start + "..." + end;
  }

  const connectWalletToken = async () => {
    if (typeof window.ethereum !== "undefined") {
      const web3Instance = new Web3(window.ethereum);
      const accountsArray = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      setWeb3(web3Instance);
      setAccounts(accountsArray);

      // Get nonce for user
      const nonceResponse = await axios.get(
        `https://www.dreamgirlstudio.ai/get-nonce?address=${accountsArray[0]}`
      );

      // Sign nonce using the updated message structure
      const message = `Please sign this nonce for authentication: ${nonceResponse.data.nonce}`;
      console.log("web3Instance", web3Instance);
      console.log(nonceResponse.data);

      console.log("Address:", accountsArray[0]);
      try {
        const customMessage =
          "Please verify your wallet so that we can check your $DREAM holdings.";
        const nonce = nonceResponse.data.nonce.toString();
        // const signature = await web3Instance.eth.personal.sign(web3Instance.utils.fromUtf8(nonce), accountsArray[0], "");

        // Customize the message as part of the structured data

        const combinedMessage = `${nonce} - ${customMessage}`;

        const signature = await web3Instance.eth.personal.sign(
          web3Instance.utils.fromUtf8(combinedMessage),
          accountsArray[0],
          ""
        );

        console.log("Combined Message:", combinedMessage);
        console.log("Signature:", signature);
        console.log("Address (Frontend):", accountsArray[0]);

        // Authenticate user and get JWT
        const authResponse = await axios.post(
          "https://www.dreamgirlstudio.ai/auth/metamask",
          {
            signature,
            address: accountsArray[0],
          }
        );

        console.log("connection data", authResponse.data);

        if (authResponse.data.message === "Insufficent $DREAM token balance") {
          toast.error(
            "You don't have enough $DREAM tokens in this wallet for Premium Mode."
          );
          setTokenBalance(authResponse.data.balance);
          return;
        }
        setAccount(authResponse.data.recoveredAddress);
        setTokenBalance(authResponse.data.balance);
        setUserToken(authResponse.data.token);
        updateAccount(authResponse.data.recoveredAddress);
        updateTokenBalance(authResponse.data.balance);
        updateUserToken(authResponse.data.token);
        console.log(authResponse.data.token);

        localStorage.setItem ('authToken', authResponse.data.token);
      } catch (error) {
        console.error("Signing error:", error);
      }
    } else {
      console.log("Ethereum browser not detected. Please install Metamask.");

      if (isMobileDevice()) {
        alert(
          "It looks like you're on a mobile device. Please visit our app on Metamask's mobile browser."
        );
        window.location.href =
          "https://metamask.app.link/dapp/www.dreamgirlstudio.ai/premium";
      } else {
        toast.error(
          "Please install the Metamask extension on your desktop browser, or download and use the Metamask mobile browser if you are on your phone.",
          { autoClose: 12000 }
        );
      }
    }
  };

  function renderWalletSubContainer() {
    if (location.pathname === "/premium") {
      if (!account && !stripeUser) {
        return (
            <div className="walletSubContainer">
            {/* <button className="stripeAuthenticate">Log In | Register</button> */}
            <div className="loginOrRegister">
                <Link className="stripeAuthenticate" to="/register">
                Register
                </Link>
                <Link className="stripeAuthenticate" to="/login">
                Login
                </Link>
            </div>
            <hr />
            <button className="connectMetamask" onClick={connectWalletToken}>
                Connect Metamask 🦊
            </button>
            <span>$DREAM balance: {tokenBalance ? "---" : tokenBalance}</span>
            </div>
        );
      } else if (account && !stripeUser) {
        return (
            <div className="walletSubContainer">
            <span>{shortenString(account)}</span>
            <br />
            <span>$DREAM balance: {tokenBalance}</span>
            <br />
            {tokenBalance >= TRHESHOLD ? (
              <span style={{ color: "pink" }}>Premium Mode Active</span>
            ) : (
              ""
            )}
            <br />
            <span
              onClick={() => {
                document
                  .getElementById("archive")
                  .scrollIntoView({ behavior: "smooth" });
              }}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              View Your Archive
            </span>
            <br />
            <span 
                onClick={() => {
                    setUserToken(null);
                    updateUserToken (null);
                    localStorage.removeItem('authToken');
                    localStorage.removeItem ("isStripeActive");
                    window.location.reload();
                }}
                style={
                    {
                        cursor: "pointer",
                        textDecoration: "underline"
                    }
                }>
                Disconnect Wallet
            </span>
          </div>
        );
      } else if (!account && stripeUser) {
        return (
            <div className="walletSubContainer">
            <span>Connected Account:</span>
            <br />
            <span>{stripeUser.username}</span>
            <br />
            <a href="/profile" className="manageAccount" >Manage Account</a>

            {/* <span style={{ color: "pink" }}>Premium Mode Active</span> */}
            {/* <br /> */}
            <span
              onClick={() => {
                document
                  .getElementById("archive")
                  .scrollIntoView({ behavior: "smooth" });
              }}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              View Your Archive
            </span>
            <br />
            <span 
                onClick={() => {
                    setUserToken(null);
                    updateUserToken (null);
                    localStorage.removeItem('authToken');
                    localStorage.removeItem ("isStripeActive");
                    window.location.reload ();
                }}
                style={
                    {
                        cursor: "pointer",
                        textDecoration: "underline"
                    }
                }>
                Logout
            </span>
          </div>
        );
      } else if (account && stripeUser) {
        return (
            <div className="walletSubContainer">
            <span>{shortenString(account)}</span>
            <br />
            <span>$DREAM balance: {tokenBalance}</span>
            <br />
            <span>Connected Account: {stripeUser.username}</span>
            <br />
            <a href="/profile" className="manageAccount" >Manage Account</a>
            {/* {tokenBalance >= TRHESHOLD ? (
              <span style={{ color: "pink" }}>Premium Mode Active</span>
            ) : (
              ""
            )} */}
            <br />
            <span
              onClick={() => {
                document
                  .getElementById("archive")
                  .scrollIntoView({ behavior: "smooth" });
              }}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              View Your Archive
            </span>
          </div>
        );
      }
    }
  }

  return (
    <div className="App">
      <div className="welcome">
        <div className="nav">
          <div className="walletStuff">
          {location.pathname === "/premium" && renderWalletSubContainer()}

            <br />
            <br />


            {location.pathname === "/" || location.pathname === "/premium" ? (
              <>
                <a
                    href="https://www.dreamgirlstudio.ai/explorer"
                    target="_blank"
                    rel="noreferrer"
                    className="explorerButton"
                >
                    Explorer
                </a>
                <a href="https://guy.dreamgirlstudio.ai/" target="_blank" rel="noreferrer" id="toDreamGuys">Check out Dream Guys</a>
                <br />
                <a href="https://discord.gg/n6XwKgfduN" target="_blank" rel="noreferrer" id="getSupport">Get Support</a>
              </>
            ) : (
              ""
            )}


            {/* <span
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <SocialIcon
                  url="https://twitter.com/dream_girl_ai"
                  style={{ maxWidth: "25px", marginRight: "13px", marginLeft: "1em" }}
                />
                {twitterUsername ? <h3>{twitterUsername}</h3> : 
                    <a className="connectTwitter" href="https://www.dreamgirlstudio.ai/auth/twitter">Twitter Login</a>
                }
              </span> */}
          </div>
        </div>
      </div>

      {/* asdfasf */}
      {/* <button onClick={getDreamBalance}>get balance</button> */}

      {/* <Premium account={account} tokenBalance={tokenBalance} imageLinks={imageLinks} userToken={userToken}  /> */}
    </div>
  );
}

function App() {
  const [account, setAccount] = useState(null);
  const [tokenBalance, setTokenBalance] = useState("0");
  const [userToken, setUserToken] = useState(null);

  return (
    <UserProvider>
      <Router>
        <ToastContainer />
        {/* <Secure /> */}
        <Navbar
          setAccount={setAccount}
          setTokenBalance={setTokenBalance}
          setUserToken={setUserToken}
        />
        <Routes>
          <Route path="/" element={<Playground />} />
          <Route
            path="/premium"
            element={
              <Premium
                account={account}
                tokenBalance={tokenBalance}
                userToken={userToken}
              />
            }
          />
          <Route path="/register" element={<Elements stripe={stripePromise}>
            <Registration />
        </Elements>} />
          <Route path="/login" element={<Login />} />
          <Route path="/explorer" element={<Explorer />} />
          <Route path="/payment/:sessionId" element={<PaymentPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/password-reset" element={<PasswordResetRequest />} />
          <Route path="/reset-password" element={<PasswordReset />} />
        </Routes>
      </Router>
      {/* <Chatbot /> */}
    </UserProvider>
  );
}

export default App;
